import { UntypedFormGroup } from '@angular/forms';

export const ForgotLoginScreenMock = {
  formGroup: new UntypedFormGroup({}),
  forgotLoginAttributes: {
    errorCount: 0,
    submitAttempt: false,
    errorAlertBanner: false,
    firstNameControlTouched: false,
    lastNameControlTouched: false,
    isMfa: false,
    emailIdControlTouched: false,
    showFormAlert: false
  },
  forgotLoginContent: {
    emailLabel: 'Email Address*',
    emailText: 'Email Address',
    firstNameLabel: 'First Name',
    firstNameText: 'First Name',
    headerSubTitle: 'All fields required',
    headerTitle: 'Forgot Login',
    lastNameLabel: 'Last Name',
    lastNameText: 'Last Name',
    emailAddressInfoContent:
      "Need to update your email address? Go to the <a href='/contactus/identityVerification'>ID Verification Form</a> to complete this.",
    nextDisplayView: {
      button_continue: '',
      button_createPassword: '',
      button_forgotPassword: '',
      button_loginHelp: '',
      button_modal: '',
      button_resetPassword: '',
      button_sendLogin: '',
      button_wfp: '',
      nextViewName: '',
      nextViewName_createPassword: '',
      nextViewName_email: '',
      nextViewName_forgotPassword: '',
      nextViewName_loginHelp: '',
      nextViewName_resetPassword: '',
      nextViewName_sendLogin: '',
      nextViewName_sqa: '',
      overlayMessage: '',
      refreshUrl: ''
    },
    viewName: '',
    forgotButtonLabel: 'Continue',
    pageHeader: {
      logoUrl:
        'https://st.delta.com/content/dam/delta-www/responsive/apps/login/supergraphic-delta.png',
      headerTitle: 'Forgot Login',
      headerSubTitle: '*fields required',
      altText: ''
    },
    errors: {
      emailIdErrorMessage: '',
      firstNameErrorMessage: '',
      lastNameErrorMessage: '',
      forgotLoginAlertWarning: '',
      formAlertErrorMessage: ''
    }
  },
  forgotLoginErrorMessages: {
    emailIdErrorMessage: 'Whoops! Please enter a valid email address.',
    firstNameErrorMessage: 'Login credential is incorrect. Please try again.',
    lastNameErrorMessage: 'Login credential is incorrect. Please try again.',
    forgotLoginAlertWarning: 'To continue, please correct the',
    formAlertErrorMessage: ''
  }
};
